import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
const WITHOUT = ['Spending hours preparing sessions', 'Searching online for new drills', 'Keeping exercises scattered everywhere', 'Repeating the same training ideas', 'Building every session from scratch', 'Struggling to organize player progression', 'Arriving on court without a clear structure'];
const WITH = ['Have your next session ready in minutes', 'Access professional drills and progressions', 'Find your coaching resources in one place', 'Build structured sessions faster', 'Train technical and tactical objectives', 'Track player development professionally', 'Step onto court prepared'];
export function Comparison() {
  return <section aria-labelledby="comparison-title" className="w-full bg-white px-4 py-8 sm:px-6" data-id="element-34" data-mp="28vozg0m6mz3b">
      <div className="mx-auto max-w-4xl" data-id="element-35" data-mp="9l5xslev4ntj">
        <h2 id="comparison-title" className="text-center font-display text-2xl uppercase leading-tight text-charcoal sm:text-4xl" data-id="element-36" data-mp="9m8p2ug3ks9z">
          Your next session can begin with another blank page...
          <span className="mt-0.5 block text-brand" data-id="element-37" data-mp="1h9h33g3jhw2d">
            Or you can have a complete system ready.
          </span>
        </h2>

        <div className="mt-4 grid gap-2.5 md:grid-cols-2" data-id="element-38" data-mp="1d8x5kbf20qfp">
          <div className="rounded-xl border border-charcoal/15 bg-ivory p-3.5" data-id="element-39" data-mp="189ubtn4iy6n1">
            <h3 className="font-head text-sm font-semibold uppercase tracking-wide text-charcoal sm:text-base" data-id="element-40" data-mp="24zl3zfpcfhpo">
              Without Padel Coach Pro™
            </h3>
            <ul className="mt-2 space-y-1.5" data-id="element-41" data-mp="20yrggnftc4xb">
              {WITHOUT.map(item => <li key={item} className="flex items-start gap-2 text-[13px] leading-snug text-softgray" data-id="element-42" data-mp="1vxbv0u9q3wee">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-urgent" aria-hidden="true" data-id="element-43" data-mp="kk9fm2jd1cvt" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-xl border border-brand/30 bg-brand/5 p-3.5" data-id="element-44" data-mp="h226mtgibwab">
            <h3 className="font-head text-sm font-semibold uppercase tracking-wide text-brand-dark sm:text-base" data-id="element-45" data-mp="gzzikeyx0d88">
              With Padel Coach Pro™
            </h3>
            <ul className="mt-2 space-y-1.5" data-id="element-46" data-mp="80cipxlu3fha">
              {WITH.map(item => <li key={item} className="flex items-start gap-2 text-[13px] leading-snug text-charcoal" data-id="element-47" data-mp="cz5w7q14f6hg">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-48" data-mp="3216xhbzauwf" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}